var $0dce8fbb66bfe765$exports = {};
/* eslint-disable jira/filename-case */ // This file is still present because Monolith requires it to be here.
// Can  be cleaned up as soon as Monolith is adjusted.


//# sourceMappingURL=global-fragment-navigation-skeleton-empty.60e4fcd8.js.map
